import styled from 'styled-components';
import { CODE_FONT_FAMILY } from 'HubStyleTokens/misc';
import H7 from 'UIComponents/elements/headings/H7';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import AccordionTree from 'automation-ui-enrollment/components/common/jsonView/AccordionTree';
import { useEffect, useState } from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAccordionHeader = styled(H7).withConfig({
  displayName: "AccordionTreeRoot__StyledAccordionHeader",
  componentId: "f7ub23-0"
})(["font-family:", ";font-size:14px;line-height:14px;"], CODE_FONT_FAMILY);
const ACCORDION_ITEM_TEXT_STYLE_SO_TEXT_ALIGNS_WITH_ICON = {
  paddingTop: 3
};
const AccordionTreeRoot = ({
  areAllBranchesOpen,
  keyString,
  value
}) => {
  const [isLocallyOpen, setIsLocallyOpen] = useState(false);
  useEffect(() => {
    setIsLocallyOpen(areAllBranchesOpen);
  }, [areAllBranchesOpen]);
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    open: isLocallyOpen,
    onOpenChange: () => {
      setIsLocallyOpen(!isLocallyOpen);
    },
    title: /*#__PURE__*/_jsxs(StyledAccordionHeader, {
      className: "m-bottom-0",
      style: ACCORDION_ITEM_TEXT_STYLE_SO_TEXT_ALIGNS_WITH_ICON,
      children: [keyString, ":"]
    }),
    children: /*#__PURE__*/_jsx(AccordionTree, {
      areAllBranchesOpen: areAllBranchesOpen,
      dataObject: value
    })
  });
};
export default AccordionTreeRoot;